import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import Moment from "moment";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { searchStoreDeposit, updateStatusStoreDeposit, deleteStoreDeposit } from "../../../Helpers/apiCalls/Reports/StoreDepositApi";
import { getCashCountReport } from "../../../Helpers/apiCalls/Reports/DailyCashCountApi";
// import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { CSVLink, CSVDownload } from "react-csv";
import { Fragment } from "react";
import { getAllCashAdvance, deleteCashAdvance } from './../../../Helpers/apiCalls/Employees/CashAdvanceApi';
import Footer from "../../../Components/Footer/Footer";
//api

export default function CashAdvance() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        employee_name: "",
        date_from: "",
        date_to: "",
        status: accountType === "admin" ? "for_approval" : "unsettled,approved",
        tab: accountType === "admin" ? "for_approval" : "unsettled,approved",
        employee_id: "",
        group_by_entry: accountType === "admin" ? "1" : "0"
    })
    // const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [totalCashAdvance, setTotalCashAdvance] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [checkedPayments, setCheckedPayments] = useState([]);
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [selectedType, setSelectedType] = useState("");
    const [excelData, setExcelData] = useState([]);

    const unsettledHeaders =  [ "NAME", "DISBMT DATE", "TYPE", "AMOUNT", "PAID AMOUNT", "BALANCE", "PAYABLE PER CYCLE", "REQUEST DATE", "PREP BY", "APPROVED BY", "CA NO." ]
    const allDataHeaders =  [ "NAME", "DISBMT DATE", "TYPE", "AMOUNT", "PAID AMOUNT", "BALANCE", "REQUEST DATE", "PREP BY", "APPROVED BY", "CA NO." ]
    
    const [showAddModal, setShowAddModal] = useState(false);
    const handleShowAddModal = () => setShowAddModal(true);
    const handleCloseAddModal = () => setShowAddModal(false); 

    /* delete modal handler */
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false); 

    const [isClicked, setIsClicked] = useState(false);
    const [selectedRow, setSelectedRow] = useState([]);
    const today = new Date();
    const sevendaysago = new Date();
    sevendaysago.setDate(sevendaysago.getDate() - 7);

    const excelHeaders = [
        // { label: "Sales Date", key: "sales_date" },
        { label: "Total Sales", key: "total_sales" },
        { label: "Branch Name", key: "branch_name" },
        { label: "Bank", key: "bank" },
        // { label: "DSR No.", key: "dsr_no" },
        { label: "Deposit Date", key: "deposited_on" },
        { label: "Transaction Type", key: "transaction_type" },
        // { label: "Deposited By", key: "deposited_by" },
    ];

    const types = [
        {
            id: "4",
            label: "Cash Advance",
            value: "cash_advance",
        },
        {
            id: "1",
            label: "Company Loan",
            value: "company_loan",
        },
        {
            id: "2",
            label: "SSS Loan",
            value: "sss_loan",
        },
        {
            id: "3",
            label: "Pagibig Loan",
            value: "pagibig_loan",
        },
    ]

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);
        

        if (e.target.value === "view") {
            if(filterConfig.tab === "unsettled,approved" || filterConfig.tab === "settled") {
                window.open("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
                // navigate("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
            } else {
                window.open("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
                // navigate("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
            }
        } else if (e.target.value === "edit") {
            navigate("/cashadvance/edit/" + row.entry_id + "/" + row.type_original)
        } else if (e.target.value === "delete") {
            handleShowDeleteModal();
        }
    }

    
    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                <option value="view" className="color-options">
                    View
                </option>
                {   ((filterConfig.tab !== "unsettled,approved" && filterConfig.tab !== "settled" && filterConfig.tab !== "disapproved" && 
                        row.status !== "settled" && row.status !== "unsettled")) && (
                        <option value="edit" className="color-options">
                            Edit
                        </option>
                    )
                }
                {
                    ((filterConfig.tab === "unsettled,approved" || filterConfig.tab === "all") 
                    && parseInt(row.paid_amount) === 0) && accountType === "admin" && (
                        <option value="delete" className="color-red">
                            Delete
                        </option>
                    )
                }
                {
                    (filterConfig.tab !== "unsettled,approved" && filterConfig.tab !== "all" && filterConfig.tab !== "settled") && (
                        <option value="delete" className="color-red">
                            Delete
                        </option>
                    )
                }
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handleView(row)}
            >
                View
            </button>
        );
    }
    function handleView(row) {
        
        setSelectedRow(row);

        if(filterConfig.tab === "unsettled,approved" || filterConfig.tab === "settled") {
            window.open("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
            // navigate("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
        } else if(filterConfig.tab === "all" && (row.status === "settled" || row.status === "unsettled")) {
            window.open("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
            // navigate("/cashadvance/view/" + row.id + "/individual" + "/" + row.type_original)
        } else {
            // window.open("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
            navigate("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
        }
    }

    function ReviewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handleReview(row)}
            >
                Review
            </button>
        );
    }
    function handleReview(row) {
        
        setSelectedRow(row);
        // window.open("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
        navigate("/cashadvance/view/" + row.entry_id + "/" + row.status + "/" + row.type_original)
    }

    function EditBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handleEdit(row)}
            >
                Edit
            </button>
        );
    }
    function handleEdit(row) {
        
        setSelectedRow(row);
        navigate("/cashadvance/edit/" + row.entry_id + "/" + row.type_original)
        // fetchReport(row.branch_id, row.sales_date)
    }

    const handleTabSelect = (key) => {
        if(key === "settled" || key === "all") {
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    tab: key,
                    group_by_entry: "0",
                    date_from: sevendaysago,
                    date_to: today,
                    type: "",
                    department: "",
                    employee_type: "",
                    status: key !== "all" ? key : "unsettled,approved,settled,for_approval"};
            });
        } else if(key === "unsettled,approved") {
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    tab: key,
                    group_by_entry: "0",
                    date_from: "",
                    date_to: "",
                    type: "",
                    department: "",
                    employee_type: "",
                    status: key !== "all" ? key : ""};
            });
        } else {
            setFilterConfig((prev) => {
                return {
                    ...prev,
                    tab: key,
                    group_by_entry: "1",
                    date_from: "",
                    date_to: "",
                    type: "",
                    department: "",
                    employee_type: "",
                    status: key !== "all" ? key : ""};
            });
        }
    };
    // 

    function handleOnCheck(row) {
        setCheckedPayments(row.selectedRows);
    }
    
    function handleNextScreen(e) {
        if(selectedType !== "") {
            navigate("/cashadvance/add/" + selectedType)
        } else {
            toast.error("Please select type", {
                style: toastStyle(),
            });
        }
    }

    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees([{label: "All Employees", value:""}, ...result]);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalCashAdvance("")
        setTotalAmount("")

        const response = await getAllCashAdvance(filterConfig);
        
        if (response.error) {
            setTotalCashAdvance("0")
            setTotalAmount("0")
            setAllData([])
        } else {
            var allBills = response.data.data.map((bill) => {
                var info = bill;
                var typeSplit = bill.type.split("_")
                info.ca_date = Moment(bill.added_on).format("MMM DD, YYYY")
                info.date = bill.avail_date !== "0000-00-00" ? Moment(bill.avail_date).format("MMM DD, YYYY") : ""
                info.dt_date = bill.disbursement_date ? Moment(bill.disbursement_date).format("MMM DD, YYYY") : ""
                info.cash_advance = bill.amount ? numberFormat(bill.amount) : "0.00"
                info.payable_per_payroll = bill.payable_per_payroll ? numberFormat(bill.payable_per_payroll) : "0.00"
                info.balance = numberFormat(bill.balance)
                info.paid_amount = numberFormat(bill.paid_amount)
                info.type_original = bill.type
                info.type = typeSplit[0].charAt(0).toUpperCase() + typeSplit[0].slice(1).toUpperCase() + " " + (typeSplit[1]?typeSplit[1]:"").toUpperCase();
                return info;
            });
            setAllData(allBills)
            
            if(filterConfig.tab === "unsettled,approved") {
                var excel = allBills.map((bill) => {
                    var info = {};
                    info.employee_name = bill.employee_name
                    info.dt_date = bill.dt_date
                    info.type = bill.type
                    info.cash_advance = bill.cash_advance
                    info.paid_amount = bill.paid_amount
                    info.balance = bill.balance
                    info.payable_per_payroll = bill.payable_per_payroll
                    info.date = bill.date
                    info.prepared_by_name = bill.prepared_by_name
                    info.approved_by_name = bill.approved_by_name
                    info.id = bill.id
                    return info;
                });
                setExcelData(excel)
            } else if(filterConfig.tab === "all") {
                var excel = allBills.map((bill) => {
                    var info = {};
                    info.employee_name = bill.employee_name
                    info.dt_date = bill.dt_date
                    info.type = bill.type
                    info.cash_advance = bill.cash_advance
                    info.paid_amount = bill.paid_amount
                    info.balance = bill.balance
                    info.date = bill.date
                    info.prepared_by_name = bill.prepared_by_name
                    info.approved_by_name = bill.approved_by_name
                    info.id = bill.id
                    return info;
                });
                setExcelData(excel)
            } 

            var total = response.data.summary? response.data.summary.total_cash_advance : "0";
            var amount = response.data.summary? response.data.summary.total_paid_amount : "0";
            setTotalCashAdvance(total);
            setTotalAmount(amount)

        }
        setShowLoader(false);
    }

    async function handleDeleteExpense() {
        setIsClicked(true);
        const response = await deleteCashAdvance(selectedRow.entry_id);
        if (response.data) {
            toast.success("Cash Advance Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Cash Advance", {
                style: toastStyle(),
            });
        }
    }
    
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        if(filterConfig.tab === "unsettled,approved") {
            XLSX.utils.sheet_add_aoa(worksheet, [unsettledHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "UnsettledCAandLoans.xlsx", { compression: true });
        } else if(filterConfig.tab === "all") {
            XLSX.utils.sheet_add_aoa(worksheet, [allDataHeaders], { origin: "A1" });
            XLSX.writeFile(workbook, "AllCAandLoans.xlsx", { compression: true });
        }
    }

    useEffect(() => {
        fetchEmployees();
        // fetchBanks();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> CA AND LOANS </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="employee_name"
                            placeholder="Search employee name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={(e) => handleShowAddModal()}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>

                {/* <div className="row mb-4 my-2 PO-filters d-flex filter">
                    <Row>
                        <Col xs={6}>
                            <Select
                                className="dropsearch-filter-col px-2 py-0 me-2 "
                                classNamePrefix="react-select"
                                defaultValue={transactionValue}
                                options={transactionOptions}
                                onChange={(e) => {
                                    setFilterConfig((prev) => {
                                        return { ...prev, "transaction_type": e.value };
                                    });
                                }}
                            />
                        </Col>
                        <Col className="d-flex justify-content-end mb-4">
                            <div className="justify-content-center align-items-center ">
                                <CSVLink
                                    className="button-primary px-3 py-3 justify-content-center align-items-center download-csv"
                                    data={allData}
                                    headers={excelHeaders}
                                    target="_blank"
                                    filename={`${getTodayDateISO()} Store Deposit`}
                                >
                                    <span className="me-2">
                                        <img
                                            width={20}
                                            height={20}
                                            src={downloadIcon}
                                        ></img>
                                    </span>
                                    Download Excel
                                </CSVLink>
                            </div>
                        </Col>
                    </Row>
                </div> */}

                <Tabs
                    activeKey={filterConfig.tab}
                    id="PO-tabs"
                    className="manager-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="pending" title="pending">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">

                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "TYPE",
                                        "DISBMT DATE",
                                        "REQUEST DATE",
                                        "NO. OF EMPLOYEE",
                                        "AMOUNT",
                                        // "BALANCE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "type",
                                        "dt_date",
                                        "date",
                                        "total_employees",
                                        "cash_advance",
                                        // "balance",
                                        "prepared_by_name",
                                        "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => EditBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="for_approval" title="for approval">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={12} lg={4} className="mb-2 mb-lg-0">

                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date From"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date To"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "TYPE",
                                        "DISBMT DATE",
                                        "REQUEST DATE",
                                        "NO. OF EMPLOYEE",
                                        "AMOUNT",
                                        // "BALANCE",
                                        "PREP BY",
                                        // "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "type",
                                        "dt_date",
                                        "date",
                                        "total_employees",
                                        "cash_advance",
                                        // "balance",
                                        "prepared_by_name",
                                        // "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ReviewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    {/* <Tab eventKey="approved" title="approved">
                        <div className="tab-content">
                            <div className="my-2 px-2 PO-filters d-flex">
                                <span className="me-4 align-middle mt-2 ps-label">
                                    Filter By:
                                </span>

                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    From:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />

                                <span className="me-4 align-middle mt-2 ps-label">
                                    To:
                                </span>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="PI-date-btn me-3 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                            </div>

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total Cash Advance: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "CA NO.",
                                        // "CA DATE",
                                        "DISBMT DATE",
                                        "REQUEST DATE",
                                        "NO. OF EMPLOYEE",
                                        "AMOUNT",
                                        "BALANCE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "id",
                                        // "ca_date",
                                        "dt_date",
                                        "date",
                                        "total_employees",
                                        "cash_advance",
                                        "balance",
                                        "prepared_by_name",
                                        "approved_by_name",
                                    ]}
                                    tableData={allData}
                                    // tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab> */}
                    <Tab eventKey="unsettled,approved" title="unsettled">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={3} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Department..."
                                    name="department"
                                    value={filterConfig.department}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, department: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Department</option>
                                    <option value="franchise">Franchise</option>
                                    <option value="sales">Sales</option>
                                    <option value="purchasing">Purchasing</option>
                                    <option value="human_resources">Human Resources</option>
                                    <option value="inventory">Inventory and Logistics</option>
                                    <option value="admin">Admin</option>
                                    <option value="maintenance">Maintenance and Repairs</option>
                                    <option value="marketing">Marketing</option>
                                    <option value="finance">Finance</option>
                                    <option value="commissary">Commissary</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, employee_type: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "NAME",
                                        "DISBMT DATE",
                                        "TYPE",
                                        "AMOUNT",
                                        "PAID AMOUNT",
                                        "BALANCE",
                                        "PAYABLE PER CYCLE",
                                        "REQUEST DATE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "employee_name",
                                        "dt_date",
                                        "type",
                                        "cash_advance",
                                        "paid_amount",
                                        "balance",
                                        "payable_per_payroll",
                                        "date",
                                        "prepared_by_name",
                                        "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    // tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="settled" title="settled">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Department..."
                                    name="department"
                                    value={filterConfig.department}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, department: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Department</option>
                                    <option value="franchise">Franchise</option>
                                    <option value="sales">Sales</option>
                                    <option value="purchasing">Purchasing</option>
                                    <option value="human_resources">Human Resources</option>
                                    <option value="inventory">Inventory and Logistics</option>
                                    <option value="admin">Admin</option>
                                    <option value="maintenance">Maintenance and Repairs</option>
                                    <option value="marketing">Marketing</option>
                                    <option value="finance">Finance</option>
                                    <option value="commissary">Commissary</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, employee_type: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2}>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterConfig.date_from}
                                        name="date_from"
                                        placeholderText={sevendaysago}
                                        onChange={(date) => {
                                            setFilterConfig((prev) => {
                                                return { ...prev, date_from: date };
                                            });
                                        }}
                                        fixedHeight
                                        className="date-filter me-4 form-control"
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                </Col>
                                <Col xs={6} lg={2}>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterConfig.date_to}
                                        name="date_to"
                                        placeholderText={today}
                                        onChange={(date) => {
                                            setFilterConfig((prev) => {
                                                return { ...prev, date_to: date };
                                            });
                                        }}
                                        fixedHeight
                                        className="date-filter ps-label-content me-5 form-control"
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                </Col>
                            </Row>

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "NAME",
                                        "DISBMT DATE",
                                        "TYPE",
                                        "AMOUNT",
                                        "PAID AMOUNT",
                                        "BALANCE",
                                        "REQUEST DATE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "employee_name",
                                        "dt_date",
                                        "type",
                                        "cash_advance",
                                        "paid_amount",
                                        "balance",
                                        "date",
                                        "prepared_by_name",
                                        "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    // tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="disapproved" title="disapproved">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter px-0 py-0 me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="react-select-container me-2"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date_from"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_from: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_to}
                                    name="date_to"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, date_to: date };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter ps-label-content me-5 form-control"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "TYPE",
                                        "DISBMT DATE",
                                        "REQUEST DATE",
                                        "NO. OF EMPLOYEE",
                                        "AMOUNT",
                                        "BALANCE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "type",
                                        "dt_date",
                                        "date",
                                        "total_employees",
                                        "cash_advance",
                                        "balance",
                                        "prepared_by_name",
                                        "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    // tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="all" title="All">
                        <div className="tab-content">
                            {/* filters */}
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    // value={branch}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, "employee_id": e.value };
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="type"
                                    value={filterConfig.type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "type": e.target.value };
                                    })}
                                >
                                    <option value="">All Types</option>
                                    <option value="cash_advance">Cash Advance</option>
                                    <option value="company_loan">Company Loan</option>
                                    <option value="sss_loan">SSS Loan</option>
                                    <option value="pagibig_loan">Pagibig Loan</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Department..."
                                    name="department"
                                    value={filterConfig.department}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, department: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Department</option>
                                    <option value="franchise">Franchise</option>
                                    <option value="sales">Sales</option>
                                    <option value="purchasing">Purchasing</option>
                                    <option value="human_resources">Human Resources</option>
                                    <option value="inventory">Inventory and Logistics</option>
                                    <option value="admin">Admin</option>
                                    <option value="maintenance">Maintenance and Repairs</option>
                                    <option value="marketing">Marketing</option>
                                    <option value="finance">Finance</option>
                                    <option value="commissary">Commissary</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) =>
                                        setFilterConfig((prev) => {
                                        return { ...prev, employee_type: e.target.value };
                                        })
                                    }
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2}>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterConfig.date_from}
                                        name="date_from"
                                        placeholderText={sevendaysago}
                                        onChange={(date) => {
                                            setFilterConfig((prev) => {
                                                return { ...prev, date_from: date };
                                            });
                                        }}
                                        fixedHeight
                                        className="date-filter me-4 form-control"
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                </Col>
                                <Col xs={6} lg={2}>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={filterConfig.date_to}
                                        name="date_to"
                                        placeholderText={today}
                                        onChange={(date) => {
                                            setFilterConfig((prev) => {
                                                return { ...prev, date_to: date };
                                            });
                                        }}
                                        fixedHeight
                                        className="date-filter ps-label-content me-5 form-control"
                                        showYearDropdown
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                </Col>
                            </Row>

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total Amount: {numberFormat(totalAmount)}
                                </span>
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total: {numberFormat(totalCashAdvance)}
                                </span>
                            </div>

                            <div className="below">
                                {/* table */}
                                <Table
                                    tableHeaders={[
                                        "-",
                                        "NAME",
                                        "DISBMT DATE",
                                        "TYPE",
                                        "AMOUNT",
                                        "PAID AMOUNT",
                                        "BALANCE",
                                        "REQUEST DATE",
                                        "PREP BY",
                                        "APPROVED BY",
                                        "CA NO.",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "employee_name",
                                        "dt_date",
                                        "type",
                                        "cash_advance",
                                        "paid_amount",
                                        "balance",
                                        "date",
                                        "prepared_by_name",
                                        "approved_by_name",
                                        "id",
                                    ]}
                                    tableData={allData}
                                    // tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>
                {
                    (filterConfig.tab === "unsettled,approved" || filterConfig.tab === "all") && (
                        <>
                        <div className="mb-3" />
                            <Row>
                                <Col lg={10} className="mt-3 mt-lg-0"></Col>
                                <Col lg={2} className="mt-3 mt-lg-0">
                                <div className="PO-filters">
                                    <button
                                        type="button"
                                        className="primary-btn"
                                        onClick={handleExport}
                                    >
                                        <span className="me-2">
                                            <img
                                                width={20}
                                                height={20}
                                                src={downloadIcon} alt=""
                                            ></img>
                                        </span>
                                        Download
                                    </button>
                                </div>
                            </Col>
                            </Row>
                        </>
                    ) 
                }
            </div>

            {/* modals */}
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="cash advance"
                onDelete={handleDeleteExpense}
                isClicked={isClicked}
            />
            
            <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD CA OR LOAN
                    </span>
                    <div className="PI-modal-body mt-3">
                        <span className="PI-modal-label">SELECT TYPE</span>
                        <Select
                            className="react-select-container mb-4"
                            classNamePrefix="react-select"
                            placeholder="Select Type..."
                            options={types}
                            onChange={(e) => setSelectedType(e.value)}
                        />
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary me-2"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={handleNextScreen}
                        className="button-primary"
                    >
                        Continue
                    </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Footer/>
        </div>
    );
}
